// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}.container-child{color:red;width:100px;height:100px;border:1px solid #000;margin:5px;border-radius:10px;background:#add8e6}.controller-container{display:flex}", ""]);
// Exports
module.exports = exports;
